<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-on="on"
        v-bind="attrs"
        class="Neutral search-input"
        color="neutralGray"
        v-model.trim="search"
        clearable
        dense
        filled
        single-line
        hide-details
        :label="searchlabel"
      >
        <template v-slot:prepend-inner>
          <v-icon size="20" class="mr-2" color="neutralGray"
            >mdi-magnify</v-icon
          >
        </template>
      </v-text-field>
    </template>
    <span>{{ searchlabelTooltip }} </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    labelTooltip: {
      type: String,
      default: "",
    },
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    searchlabel() {
      // console.log(
      //   this.label && this.label != "" ? this.label : this.$t("lblSearchText"),
      //   "this.label----"
      // );
      return this.label && this.label != ""
        ? this.label
        : this.$t("lblSearchText");
    },
    searchlabelTooltip() {
      return this.labelTooltip && this.labelTooltip != ""
        ? this.labelTooltip
        : this.$t("lblSearchTooptip");
    },
  },
};
</script>

<style scoped>
.search-input {
  height: 34px;
  width: 278px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
  border-radius: 0 !important;
}
.search-input > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
}

.search-input /deep/ .v-input__slot {
  min-height: 34px !important;
  /* width: 240px !important; */
}

.search-input /deep/ .v-label {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  color: var(--v-neutralGray-base) !important;
}
.search-input /deep/ input {
  line-height: 16px !important;
}

.theme--light.search-input > .v-input__control > .v-input__slot:before {
  border-color: #cccccc !important;
}
.theme--light.search-input > .v-input__control > .v-input__slot:after {
  border-color: var(--v-neutralGray1-base) !important;
}
.theme--dark.v-input /deep/ input {
  color: var(--v-neutralGray-base) !important;
}
.theme--dark.v-input /deep/ .v-icon {
  color: var(--v-neutralGray-base) !important;
  font-size: 20px !important;
}
</style>